import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { AssigneesResponse, AuthorizationGuard } from "../types";

interface GetAssigneesProps {
  guardName: AuthorizationGuard;
  search: string;
  page: number;
  perPage?: number;
}

interface GetAssigneesRequest extends GetAssigneesProps {
  token: string;
}

export const QUERY_KEY_FOR_ASSIGNEES = "authorization-assignees";
const AUTHORIZATION_URL = `${END_POINT.BASE_URL}/v1/administrator/authorization`;

const getAssignees = async ({
  token,
  guardName,
  search,
  page,
  perPage = 20,
}: GetAssigneesRequest): Promise<AssigneesResponse> => {
  const response = await axios.get<AssigneesResponse>(
    `${AUTHORIZATION_URL}/assignees`,
    {
      params: {
        guard_name: guardName,
        search,
        page,
        per_page: perPage,
      },
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const useGetAssignees = (props: GetAssigneesProps) => {
  const { token } = useGetUserInfo();
  return useQuery<AssigneesResponse, Error>(
    [
      QUERY_KEY_FOR_ASSIGNEES,
      props.guardName,
      props.search,
      props.page,
      props.perPage,
    ],
    () => getAssignees({ ...props, token }),
    {
      enabled: Boolean(token),
      keepPreviousData: true,
    }
  );
};
